import styled from 'styled-components'
import { motion } from 'framer-motion'
import { useTranslation } from 'react-i18next'
import config from '@/config'
import useMediaQuery from '@/hooks/use-media-query'
import { colors, breakpoints, structure } from '@/styles'
import Skeleton from '@/components/skeleton'
import { EditListing, ExternalLink } from '@/components/icons'
import TenantInfo from './tenant-info'

const { APP_PATH } = config

const Wrapper = styled.section`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 48px;
  padding: 40px;
  background: #f7f8fb;
  border-left: 1px solid #d2d7df;
  flex: 1;
  min-height: calc(100vh - ${structure.header.height}px);
  /* max-height: calc(100vh - ${structure.header.height}px); */

  @media screen and (max-width: 1280px) {
    max-height: none;
    height: 100%;
  }

  @media screen and (max-width: 991px) {
    display: none;
  }
`

const Container = styled(motion.div)`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  gap: 48px;
  flex: 1;
  max-width: 420px;
  width: 100%;
  min-width: 310px;
`

const Row = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  gap: 6px;
`

const ActionButtons = styled.div`
  display: flex;
  flex-direction: row;
  gap: 24px;
  width: 100%;
`

const ViewListing = styled.div`
  background: ${colors.formAccent};
  border: 1px solid ${colors.formAccent};
  border-radius: 4px;
  padding: 12px 20px;
  gap: 6px;
  cursor: pointer;
  color: white;

  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  flex: 1;
  transition: all 0.3s ease-in-out;
  &:hover {
    box-shadow: 0px 6px 8px -2px rgba(29, 66, 94, 0.4), 0px 12px 16px rgba(32, 121, 193, 0.15);
  }
`

const Relist = styled(ViewListing)`
  background: white;
  color: ${colors.formAccent};
  flex: 1;
  &:hover {
    background-color: ${colors.grey96};
    box-shadow: none;
  }
`

type Props = {
  verifyCreateListing: any
  tenants: any
  contract: any
  listingId: string
  showSkeleton: boolean
}

const TenantDashboardSidebar = ({
  tenants,
  contract,
  verifyCreateListing,
  listingId,
  showSkeleton
}: Props) => {
  const isMobile = useMediaQuery(`(max-width: ${breakpoints.phoneMax})`)
  const { t } = useTranslation()

  return (
    <Wrapper>
      <Container initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 1 }}>
        {showSkeleton ? (
          <Skeleton height={50} width={400} />
        ) : (
          <ActionButtons>
            <ViewListing onClick={() => window.open(`${APP_PATH}/tenant/${listingId}/details`)}>
              <ExternalLink />
              {t('l.tenants.view.view_listing.link', 'View listing')}
            </ViewListing>

            <Relist onClick={() => verifyCreateListing(listingId)}>
              <EditListing />
              {t('l.tenants.view.relist_listing.link', 'Re-list listing')}
            </Relist>
          </ActionButtons>
        )}

        {showSkeleton ? (
          <Skeleton height={220} width={400} />
        ) : (
          <TenantInfo tenants={tenants} contract={contract} />
        )}
      </Container>
    </Wrapper>
  )
}

export default TenantDashboardSidebar
